import { TransactionType, } from './TransactionStepDialog.types';
export const isMessageSignatureRequest = (request) => request.type === TransactionType.signMessage;
export const isTypedDataRequest = (request) => request.type === TransactionType.signTypedData;
export const isTransactionRequest = (request) => request.type === TransactionType.signTransaction;
export const isSignTransactionDataRequest = (request) => request.type === TransactionType.signTransactionData;
/**
 * What a send check rejects with when it refuses a transaction: nothing is
 * sent, and `reasons` are the lines that say why, as the user was told them.
 */
export const sendRefusal = (reasons) => Object.assign(new Error('The send check refused, so nothing was sent.'), {
    notSentReasons: reasons,
});
/** The reasons a send check's rejection names; none when it names none. */
export const notSentReasonsOf = (rejection) => {
    const reasons = rejection === null || rejection === void 0 ? void 0 : rejection.notSentReasons;
    return Array.isArray(reasons)
        ? reasons.filter((reason) => typeof reason === 'string')
        : [];
};
